<template>
  <div class="Proyecto">
    <v-container grid-list-md fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md8>
          <v-card class="mb-2">
            <v-card-title class="title">
              Reporte por Proyecto
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <chart-column
                :chartOptions="chartOptions"
                :chartSeries="chartSeries"
                :key="chartKey"
              />

              <table-plain
                :headers="headers"
                :dataVals="dataVals"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import chartColumn from '@/components/Charts/ColumnBase'
import tablePlain from '@/components/Tables/TablePlain'

export default {
  name: 'Proyecto',

  components: {
    'chart-column': chartColumn,
    'table-plain': tablePlain
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadData()
  },

  data: function () {
    return {
      backConf: {
        path: '/semcali/rp_pry',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      chartKey: 0,

      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],

      chartSeries: null,
      chartOptions: {
        chart: {
          height: 350,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [
            'P01.', 'P02.', 'P02.1.', 'P03.', 'P03.1.', 'P04.',
            'P05.', 'P06.', 'P07.', 'P08.', 'P09.', 'P10.'
          ],
          title: {
            text: 'Tipo de Proyecto'
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      },

      headers: [
        {
          text: 'Proyecto',
          align: 'left',
          value: 'project',
          sortable: false
        },
        { text: 'Nombre', value: 'name', sortable: false }
      ],

      dataVals: [
        { project: 'P01.', name: 'Conformación de Semilleros TIC.' },
        { project: 'P02.', name: 'Fortalecimiento de las competencias básicas de los estudiantes.' },
        { project: 'P02.1.', name: 'Semilleros de cultura ciudadana.' },
        { project: 'P03.', name: 'Implementación de sistemas de gestión de calidad escolar.' },
        { project: 'P03.1.', name: 'Gestión calidad: Mediadores de comunicación' },
        { project: 'P04.', name: 'Mejoramiento de la gestión curricular.' },
        { project: 'P05.', name: 'Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.' },
        { project: 'P06.', name: 'Recreación en actividades lúdicas para niños y niñas de la primera infancia.' },
        { project: 'P07.', name: 'Adecuación de espacios de ludoteca.' },
        { project: 'P08.', name: 'Recreación a través de la Iniciación y Formación Deportiva.' },
        { project: 'P09.', name: 'Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.' },
        { project: 'P10.', name: 'Capacitación en iniciación y sensibilización artística en comunas y corregimientos.' }
      ]
    }
  },

  methods: {
    /**
     * Carga los datos de las encuestas
     */
    loadData () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeries = resp.data
          t.loading = false
          t.chartKey += 1
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
